module.exports = __webpack_public_path__ + "static/media/valor1.936aad13.png";